import $ from 'jquery'
import select2 from 'select2'

const fadePostsIn = () => {
    $('.postGrid').stop().fadeTo( "fast" , 1)
}

const fadePostsOut = () => {
    $('html, body').stop().animate({ scrollTop: 135 }, 600)
    $('.postGrid').stop().css( "opacity" , 0.6)
}

function init() {

    $(document).on('facetwp-loaded', function() {

        fadePostsIn()

        $('.facetwp-dropdown, .facetwp-sort-select').select2({
            minimumResultsForSearch : -1,
            width : 'resolve'
        })
        .on('change', fadePostsOut)
        .on('select', fadePostsOut)

        $('.facetwp-pager .pagination').on('click', fadePostsOut)

        $('.facetwp-checkbox').on('click', fadePostsOut)
        
     })

}
  
export default {
    init,
}

  